const PublicHeader = (props) => {
    const divStyle = {
        backgroundImage: ` linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),  url(${props.image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        // backgroundColor: "rgba(0, 0, 0, 0.5)",
        // height: "100vh", // Set to viewport height
        width: "100%", // Full width
      };
    return(
        <div className="about-section" style={divStyle}>
        <h1>{props.name}</h1>
        <p>Some text about who we are and what we do.</p>
        <p>Resize the browser window to see that this page is responsive by the way.</p>
      </div>
    )
}

export default PublicHeader;